import { View } from "@react-pdf/renderer"
import { colors } from "../../../src/config/theme"

const Separator = ({ color = colors.primary }: { color?: string }) => (
  <View
    style={{
      height: 2,
      width: 108,
      backgroundColor: color,
      marginBottom: 32,
    }}
  />
)

export default Separator
